export const LOAD_RECENT = "LOAD_RECENT";
export const DELETE_WATCH_URL = "DELETE_WATCH_URL";
export const ACKNOWLEDGE = "ACKNOWLEDGE";
export const LOAD_MONTHLY_DATA = "LOAD_MONTHLY_DATA";
export const STOP_LOADING = "STOP_LOADING";
export const START_LOADING = "START_LOADING";
export const LOAD_MONTHLY_SAFE_DANGER = "LOAD_MONTHLY_SAFE_DANGER";
export const LOAD_WATCH_LIST = "LOAD_WATCH_LIST"
export const POST_WATCH_LIST = "POST_WATCH_LIST"